/**
 * @generated SignedSource<<c0f49593e396676baed39d2b3d5b2cae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetEmployeeRoleOverviewInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds: ReadonlyArray<string>;
};
export type WAEmployeeRoleOverviewMutation$variables = {
  input: CreateWidgetEmployeeRoleOverviewInput;
  storecastId: string;
};
export type WAEmployeeRoleOverviewMutation$data = {
  readonly dashboard: {
    readonly createWidgetEmployeeRoleOverview: {
      readonly id: string;
    };
  };
};
export type WAEmployeeRoleOverviewMutation = {
  response: WAEmployeeRoleOverviewMutation$data;
  variables: WAEmployeeRoleOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetEmployeeRoleOverview",
        "kind": "LinkedField",
        "name": "createWidgetEmployeeRoleOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAEmployeeRoleOverviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAEmployeeRoleOverviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2c840cbc4a7524a84a8bfdab26df7f1c",
    "id": null,
    "metadata": {},
    "name": "WAEmployeeRoleOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WAEmployeeRoleOverviewMutation(\n  $storecastId: ID!\n  $input: CreateWidgetEmployeeRoleOverviewInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetEmployeeRoleOverview(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "46ed038e8ff2a235c34b77de69aeb464";

export default node;
